module.exports = __webpack_public_path__ + "img/suc2.4334a86b.png";